declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
  }
}

const logTrackEvent = (eventName: string, data?: object) => {
  if (import.meta.env.MODE !== 'production') {
    console.info(
      `%cEvent %c ${eventName}`,
      'color: #FF8118; font-size:16px;',
      'color: #00B9F3; font-size:16px;',
      data
    );
  }
};

export const track = (eventName: string, data?: object) => {
  const dataLayer = window.dataLayer;

  if (!dataLayer) {
    console.warn('GTM dataLayer not available');
    return;
  }

  const userId = window.sessionStorage.getItem('user_id');

  try {
    dataLayer.push({
      event: eventName,
      ...data,
      ...(userId && {user_id: userId}),
    });
  } catch (error) {
    console.warn('Analytics track failed:', error);
  }

  logTrackEvent(eventName, data);
};
